/**
 * Created by vladzur on 04-07-16.
 */

export function getError (state) {
  return state.error
}

export function getCurrentChampionship (state) {
  return state.current_championship
}

export function getCurrentDate (state) {
  return state.current_date
}

export function getCurrentCourse (state) {
  return state.current_course
}

export function getCurrentPlayer (state) {
  return state.current_player
}

export function getLoading (state) {
  return state.loading
}

export function getRegistrations (state) {
  return state.registrations
}

export function getCurrentCard (state) {
  return state.current_card
}

export function getHolesIn (state) {
  return state.holes_in
}

export function getHolesOut (state) {
  return state.holes_out
}

export function getPlayersWaiting (state) {
  return state.players_waiting
}

export function getPlayersReady (state) {
  return state.players_ready
}

export function getCardSaved (state) {
  return state.card_saved
}

export function getPlayerCards (state) {
  return state.player_cards
}

export function getShowPlayerCards (state) {
  return state.show_player_cards
}

export function getShowPlayer (state) {
  return state.show_player
}

export function getShowCard (state) {
  return state.show_card
}

export function getConfigCategories (state) {
  return state.configuration.categories
}

export function getConfigCategory (state) {
  return state.configuration.category
}

export function getConfigPlayer (state) {
  return state.configuration.player
}

export function getConfigChampionship (state) {
  return state.configuration.championship
}

export function getConfigDates (state) {
  return state.configuration.dates
}

export function getConfigCourses (state) {
  return state.configuration.courses
}

export function getConfigRegistrations (state) {
  return state.configuration.registrations
}

export function getConfigTeams (state) {
  return state.configuration.teams
}

export function getConfigTeam (state) {
  return state.configuration.team
}

export function getConfigAwards (state) {
  return state.configuration.awards
}



/** WEBPACK FOOTER **
 ** ./src/vuex/getters.js
 **/